<template>
    <div class="p-col-12">
        <page-header title="forms.client.title" v-if="showHeader"/>
            <card :header="$t('forms.client.card-personal-information')" class="p-col-12" >
                <coff-input-auto-complete v-if="form.id == null" v-model="form.name" label="forms.client.name" class="p-col-12 p-md-6 p-lg-4" :itens="clients" field="name" :func-suggestions="searchClient" :debounce-time="350" :error="validation.name"/>
                <coff-input-text v-else v-model="form.name" label="forms.client.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
                <coff-input-date v-model="form.birthDay" label="forms.client.birthDay" class="p-col-12 p-md-6 p-lg-4" :error="!form.birthDay" :max-date="new Date()" />

<!--                <coff-input-text v-model="form.tags" label="forms.client.tags" class="p-col-12 p-md-6 p-lg-4" />-->
                <coff-input-select v-model="form.gender" label="forms.client.gender" class="p-col-12 p-md-6 p-lg-4" :options="genders" :translate="true" option-value="id" :error="!form.gender"/>
<!--                <coff-input-radio v-model="form.typeOfPerson" @update="updateTypeOfPerson($event)" :options="typesOfPerson" label="forms.client.typeOfPerson"
                                  optionLabel="name" optionValue="id" class="p-col-12 p-md-6 p-lg-4" :error="validation.typeOfPerson"/>-->
                <coff-input-text v-model="form.document" :label="typeOfPersonSelected" class="p-col-12 p-md-6 p-lg-4" :error="validation.document"
                                 :mask="maskDocument" :disable="!form.typeOfPerson"/>
                <coff-input-text v-model="form.rg" label="forms.client.rg" class="p-col-12 p-md-6 p-lg-4" mask="rg"/>
                <coff-input-select v-model="form.maritalStatus" label="forms.client.maritalStatus" class="p-col-12 p-md-6 p-lg-4" :options="maritalStatusList" :translate="true" option-value="id" :error="!form.maritalStatus"/>
            </card>

            <card :header="$t('forms.client.card-relationship')" class="p-col-12" >
<!--              <coff-input-auto-complete v-model="form.mother" label="forms.client.mother" class="p-col-12 p-md-5 p-lg-5" :itens="clients" field="name" :func-suggestions="searchClient"/>
              <a class="cursor-pointer p-col-1 p-md-1 p-lg-1" @click.prevent="modalClientForm('mother')" style="margin-top: 30px;"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>-->
              <coff-input-text v-model="form.motherName" label="forms.client.mother-name" class="p-col-12 p-md-6 p-lg-6" field="name" />

<!--              <coff-input-auto-complete v-model="form.father" label="forms.client.father" class="p-col-12 p-md-5 p-lg-5" :itens="clients" field="name" :func-suggestions="searchClient"/>
              <a class="cursor-pointer p-col-1 p-md-1 p-lg-1" @click.prevent="modalClientForm('father')" style="margin-top: 30px;"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>-->
              <coff-input-text v-model="form.fatherName" label="forms.client.father-name" class="p-col-12 p-md-6 p-lg-6" field="name" />

              <hr style="width: 100%"/>
              
              <coff-input-text v-model="form.spousesName" v-if="form.spousesName" label="forms.client.spouse-name" class="p-col-12 p-md-12 p-lg-12" :disable="true"/>
              <div class="p-col-5 p-md-3 p-lg-3 p-mt-3 text-vertical-center">
                <a class="cursor-pointer p-md-1" @click.prevent="addEditSpouse()">
                  <Button icon="pi pi-plus small" class="p-button-rounded small-rounded-button" :title="$t('forms.client.add-spouse')" />
                  {{$t('forms.client.add-spouse')}}
                </a>
              </div>

              <div class="p-col-12">
                <div v-for="(spouse, index) in spousesSorted" :key="index">
                  <div class="p-d-flex p-col-12 line-content line-of-service p-mb-2" :class="{'spouses-success': isWeddingComplete(spouse),'spouses-warning': !isWeddingComplete(spouse), 'bold': spouse.current}">
                    <div class="text-vertical-center">
                        <span v-html="formattedSpouseInfo(spouse)"/>
                    </div>
                    <div class="p-ml-auto text-vertical-center small" style="min-width: fit-content;">
                      <a class="cursor-pointer" @click.prevent="addEditSpouse(spouse, index)"><i class="p-ml-2 pi pi-pencil small" :title="$t('forms.client.edit-spouse')"/></a>
                      <a class="cursor-pointer" @click.prevent="removeSpouse(spouse, index)"><i class="p-ml-2 pi pi-times small" :title="$t('forms.client.remove-spouse')"/></a>
                    </div>
                  </div>
                </div>
              </div>

            </card>

            <card :header="$t('forms.client.card-places-information')" class="p-col-12" >
                <coff-input-select v-model="form.birthCountry" label="forms.client.birthCountry" class="p-col-12 p-md-6 p-lg-4" :options="countries" option-value="id" option-label="country" :error="!form.birthCountry"/>
                <coff-input-select v-model="form.birthState" label="forms.client.birthState" class="p-col-12 p-md-6 p-lg-4" :options="states" :translate="true" option-value="id" v-if="form.birthCountry === 'BRASIL'" :error="!form.birthState"/>
                <coff-input-text v-model="form.birthCity" label="forms.client.birthCity" class="p-col-12 p-md-6 p-lg-4" :error="!form.birthCity"/>
                <coff-input-radio v-model="form.alive" @update="forceUpdateFieldForm('alive', $event)" :options="options" label="forms.client.alive" class="p-col-12"/>
                <template v-if="!form.alive">
                    <coff-input-date v-model="form.deathDay" label="forms.client.deathDay" class="p-col-12 p-md-6 p-lg-4" :min-date="form.birthDay" :max-date="new Date()" :error="!form.deathDay"/>
                    <coff-input-select v-model="form.deathCountry" label="forms.client.deathCountry" class="p-col-12 p-md-6 p-lg-4" :options="countries" option-value="id" option-label="country" :error="!form.deathCountry"/>
                    <coff-input-select v-model="form.deathState" label="forms.client.deathState" class="p-col-12 p-md-6 p-lg-4" :options="states" :translate="true" option-value="id" v-if="form.deathCountry === 'BRASIL'" :error="!form.deathState"/>
                    <coff-input-text v-model="form.deathCity" label="forms.client.deathCity" class="p-col-12 p-md-6 p-lg-4" :error="!form.deathCity"/>
                </template>
            </card>

            <card :header="$t('forms.client.card-contact-information')" class="p-col-12" >
                <coff-input-text v-model="form.phoneNumber" label="forms.client.phoneNumber" class="p-col-12 p-md-6 p-lg-4" mask="phone"/>
                <coff-input-text v-model="form.cellPhoneNumber" label="forms.client.cellPhoneNumber" class="p-col-12 p-md-6 p-lg-4" mask="cellPhone"/>
                <coff-input-email v-model="form.email" ref="email" label="forms.client.email" class="p-col-12 p-md-6 p-lg-4" :error="validation.email"/>
            </card>

            <card :header="$t('forms.address.card-information')" class="p-col-12" >
                <coff-input-select v-model="form.address.country" label="forms.address.country" class="p-col-12 p-md-6 p-lg-4" :options="countries" option-value="id" option-label="country"/>
                <coff-input-text v-model="form.address.zipCode" label="forms.address.zipCode" class="p-col-12 p-md-6 p-lg-4" mask="zipcode" />
                <coff-input-select v-model="form.address.state" label="forms.address.state" class="p-col-12 p-md-6 p-lg-4" :options="states" :translate="true" option-value="id" v-if="form.address.country === 'BRASIL'"/>
                <coff-input-text v-model="form.address.foreignState" label="forms.address.state" class="p-col-12 p-md-6 p-lg-4" v-else/>
                <coff-input-text v-model="form.address.city" label="forms.address.city" class="p-col-12 p-md-6 p-lg-4" />
                <coff-input-text v-model="form.address.district" label="forms.address.district" class="p-col-12 p-md-6 p-lg-4" />
                <coff-input-text v-model="form.address.street" label="forms.address.street" class="p-col-12 p-md-6 p-lg-4" />
                <coff-input-text v-model="form.address.number" label="forms.address.number" class="p-col-12 p-md-6 p-lg-4" />
                <coff-input-text v-model="form.address.complement" label="forms.address.complement" class="p-col-12 p-md-6 p-lg-4" />
            </card>

            <div class="p-col-12 p-mb-5">
                <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;" @click.prevent="save"/>
            </div>
    </div>
</template>

<script>

    import ValidationUtils from "@/utils/ValidationUtils";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import EventBus from "@/commons/EventBus";
    import PageHeader from "@/components/page/PageHeader";
    import ClientBusiness from "@/business/ClientBusiness";
    import AddressBusiness from "@/business/AddressBusiness";
    import DateUtils from "@/utils/DateUtils";
    import CountryBusiness from "@/business/CountryBusiness";
    import Utils from "@/utils/Utils";
    import DialogService from "@/business/ModalBusiness";
    import ModalClientWeddingForm from "@/viewer/client/ModalClientWeddingForm";
    import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation.vue";
    import ClientDuplicateConfirmation from "@/components/dialog/ClientDuplicateConfirmation.vue";

    export default {
        name: "ClientForm",
        components: {PageHeader},

        props:{
          showHeader: {type: Boolean, default: true},
          clientId: null,
          modalId: null,
        },

        watch: {
          'form.name': async function() {
            if(Utils.isObject(this.form.name)){
              const formTemp = {...this.form, ...await ClientBusiness.getById(this.form.name.id)};
              await this.loadClient(formTemp);
            }
          },
        },

        computed: {

            typeOfPersonSelected(){
                return !this.form.typeOfPerson ? 'forms.client.document' : this.form.typeOfPerson === 'PERSON' ? 'forms.client.cpf' : 'forms.client.cnpj';
            },

            maskDocument(){
                return this.form.typeOfPerson === 'PERSON' ? 'cpf' : 'cnpj';
            },

            spousesSorted() {
              if (this.form.spouses) {
                return [...this.form.spouses]
                      .filter(s => s.date !== null)
                      .sort((a, b) => (b.date || 0) - (a.date || 0));
              } else {
                return [];
              }
            },

        },

        data(){
            return {
                toStringDate: DateUtils.toStringDate,
                form: {
                    address: {},
                    spouses: [],
                    typeOfPerson: 'PERSON',
                    alive: true,
                },
                validation: {
                    name: false,
                    typeOfPerson: false,
                },
                options: [
                    {value: true, label: 'field.default.yes'},
                    {value: false, label: 'field.default.no'}
                ],
                genders: ClientBusiness.getGenders(),
                typesOfPerson: ClientBusiness.getTypeOfPerson(),
                states: AddressBusiness.getStates(),
                countries: CountryBusiness.getCountries(),
                clients: [],
                spouseForm: {
                    selectedSpousePerson: null,
                },
                maritalStatusList: ClientBusiness.getMaritalStatus(),
            }
        },
        async mounted(){
            const id = this.clientId || this.$route?.params?.id;
            if(id){
                let form =  {... await ClientBusiness.getById(id)};
                await this.loadClient(form);
            }
        },
        methods:{
          
            getStateLabel: AddressBusiness.getStateLabel,
            getCountryLabel: CountryBusiness.getCountryLabel,

            async loadClient(form) {
              form.birthDay = DateUtils.toStringDate(form.birthDay);
              //if(form.marriedDay) form.marriedDay = DateUtils.toStringDate(form.marriedDay);
              if(form.deathDay) form.deathDay = DateUtils.toStringDate(form.deathDay);
              if(!form.address) form.address = {};
              form = this.initializeWeddingDates(form);
              this.form = form;
            },

            formattedSpouseInfo(spouse) {
              return `${this.$t('forms.client.wedding-current')} 
                      ${spouse.current ? this.$t('field.default.yes') : this.$t('field.default.no')},
                      ${this.$t('forms.client.marriedDay')}: 
                      ${spouse.date ? this.$d(spouse.date, 'short') : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`},
                      ${this.$t('forms.client.spouse')}: <a class="cursor-pointer" target="_blank" href="#/client/${this.getSpouse(spouse).id}/details">${this.getSpouse(spouse).name}</a><br/>
                      ${this.$t('forms.client.weddingCountry')}: ${spouse.weddingCountry ? this.getCountryLabel(spouse.weddingCountry) : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`},
                      ${spouse.weddingCountry === 'BRASIL'  ? (this.$t('forms.client.weddingState')+': ' + (this.isStateComplete(spouse) ? this.$t(this.getStateLabel(spouse.weddingState)) : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`) +',') : ''}
                      ${this.$t('forms.client.weddingCity')}: ${spouse.weddingCity ? spouse.weddingCity : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`}
                      `;
            },
            isWeddingComplete(spouse) {
              return this.isStateComplete(spouse) && spouse.weddingCountry && spouse.weddingCity && spouse.date;
            },

            isStateComplete(spouse) {
              return (spouse.weddingState && spouse.weddingCountry === 'BRASIL')
            },
            initializeWeddingDates(form) {
                if (form.spouses) {
                  form.spouses.forEach(wedding => {
                    wedding.date = DateUtils.toStringDate(wedding.date);
                  });
                }
                return form;
            },
            async save(closeModal){
                if (closeModal !== false) {
                  closeModal = true;
                }
                this.validation = ValidationUtils.basicValidation(this.validation, this.form);
                this.validation.erros = this.$refs.email.emailValidation(this.validation.erros);
                if(!this.validation.erros){
                    if (!this.form.id && this.form.name) {
                      const existentClients = (await this.searchClient(this.form.name)).filter(client => client.name.toUpperCase() == this.form.name.toUpperCase());
                      if (existentClients && existentClients.length > 0) {
                        const newClientConfirmation = await DialogService.openModal(ClientDuplicateConfirmation, {message: 'forms.client.clientAlreadyExists', clients: existentClients});
                        if (newClientConfirmation === false) {
                          return;
                        }
                        if (Utils.isObject(newClientConfirmation)) {
                          const formTemp = {...await ClientBusiness.getById(newClientConfirmation.id)};
                          await this.loadClient(formTemp);
                          return;
                        }
                      }
                    }
                    this.form.father = this.normalizeObjectField(this.form.father);
                    this.form.mother = this.normalizeObjectField(this.form.mother);
                    const response = await ClientBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
                    if(response){
                        await this.loadClient(response);
                        ToastMessageBusiness.showSuccess();
                        if (closeModal) {
                          EventBus.$emit('client_saved_'+this.modalId, response);
                        }
                    }
                }
            },

            updateTypeOfPerson(typeOfPerson){
                this.$set(this.form, 'typeOfPerson', typeOfPerson);
            },

            async searchClient(name){
              return await ClientBusiness.search(name);
            },

            normalizeObjectField(field){
              return field instanceof Object ? field : null;
            },

            async addEditSpouse(spouse){
              if(spouse) {
                spouse.selectedSpousePerson = this.getSpouse(spouse);
              } else {
                spouse = {};
              }
              const spouseForm = await DialogService.openModal(ModalClientWeddingForm, {spouseForm: spouse, clientForm: this.form}, 800);
              if(spouseForm){
                if(!this.form.id) {
                  await this.save(false);
                }
                spouseForm.spouseA = {...spouseForm.selectedSpousePerson};
                spouseForm.spouseB = {id: this.form.id, name: this.form.name};
                if(!spouse.id) {
                  if (!this.form.spouses) {
                    this.form.spouses = [];
                  }
                  this.form.spouses.push(spouseForm);
                }                
                await this.save(false);
              }
            },

            forceUpdateFieldForm(field, value){
                this.$set(this.form, field, value);
            },

            async removeSpouse(spouse){
              if(spouse && await DialogService.openConfirmationModal(AncestrylineConfirmation)) {
                const spouses = this.form.spouses.filter(s => s.id !== spouse.id);
                this.$set(this.form, 'spouses', spouses);
                await this.save(false);
              }
            },

            getSpouse(spouse){
              return this.form.id === spouse.spouseA?.id ? spouse.spouseB : spouse.spouseA;
            },
        }
    }
</script>

<style scoped>

  .spouses-success {
    background-color: #8cd795;
  }

  .spouses-warning {
    background-color: #efc46f;
  }

</style>
